import { writable } from 'svelte/store';
export const isAppReady = writable(false);
